import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { cutString } from '../../../../../common/utils';
import { globalData } from '../../../../../common/common';

const Root = styled(Box)({
    width: '150px',
    padding: '8px',
    backgroundColor: '#FAFAFA',
    '& .personTitle': {
        fontSize: '14px',
        marginBottom: '8px',
    },
    '& .dragDom': {
        minWidth: '110px',
        float: 'left',
        position: 'absolute',
        backgroundColor: '#fff',
        cursor: 'pointer',
        color: '#009CEE',
        border: '1px solid #009CEE',
        borderRadius: '50px',
        marginBottom: '8px',
        padding: '0 5px',
        MozUserSelect: 'none',
        WebkitUserSelect: 'none',
        msUserSelect: 'none',
        KhtmlUserSelect: 'none',
    },
    '& .itemsWapper': {
        width: '100%',
    },
    '& .itemWapper': {
        width: '100%',
        backgroundColor: '#fff',
        cursor: 'pointer',
        color: '#009CEE',
        border: '1px solid #009CEE',
        borderRadius: '50px',
        marginBottom: '8px',
        padding: '0 5px',
        MozUserSelect: 'none',
        WebkitUserSelect: 'none',
        msUserSelect: 'none',
        KhtmlUserSelect: 'none',
    },
    '& .itemWapper:hover': {
        backgroundColor: '#009CEE',
        color: '#fff',
    },
    '& .itemWapperSelect': {
        padding: '10px 15px',
        cursor: 'pointer',
        backgroundColor: '#009CEE',
        color: '#fff',
    },
})

class PanelList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pList: []
        }
        // this.handleCancel = this.handleCancel.bind(this);
    }
    render() {
        const { pList } = this.state;
        return (
            <Root className="c">
                <div className="personTitle">Saved Person</div>
                <div className="itemsWapper">
                    {pList.map((obj, index) => (
                        <div key={index} id={index} className={"itemWapper c"} title={obj[".CHO.N."]} onClick={e => this.handleClick(e, obj)}>{cutString(obj[".CHO.N."], 11)}</div>
                    ))}
                </div>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const pList = globalData.singleArr;
        console.log("oooooooo",pList)
        this.setState({
            pList
        })
    }
    handleClick(e, obj) {
        // this.props.pickPerson(obj);
    }
}

export default PanelList;